import * as React from 'react';
import { IOrderSummarySection } from '@applications/order-tracker/config/order-tracker-new-common/types';
import Divider from '@able/react/dist/Divider'
import Spacing from '@able/react/dist/Spacing';
import TextStyle from '@able/react/dist/TextStyle';

export const ProductDetailsSection = (props: IOrderSummarySection) => {
    return (
        <React.Fragment>
            <Spacing bottom="spacing3x">
                <TextStyle alias="HeadingC" element="h3">
                {props.title}
                </TextStyle>
            </Spacing>
            {props.descriptionGroup}
            <Divider colour="dividerSubtle" />
        </React.Fragment>
    );
};
